//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import {
  IPartialState,
  NavGroup,
  StateFactory,
  componentNameToTemplate,
  hasFeature,
  lazyLoadModule,
} from 'app/initialization/routing/stateHelpers';

function AgentsDashboardStateFactory(state: IPartialState) {
  const accessFn = state.data?.hasAccess ?? (() => true);
  const data = {
    title: 'Agents',
    navGroup: NavGroup.AGENTS,
    ...state.data,
    hasAccess: () => hasFeature(FeatureNames.AgentsDashboard) && accessFn(),
  };
  return StateFactory({
    ...state,
    data,
  });
}

export const states = {
  agentsDashboard: AgentsDashboardStateFactory({
    url: '/agents',
    template: componentNameToTemplate('agentsDashboardPage'),
    data: {
      title: 'Agents',
      navGroup: NavGroup.AGENTS,
    },
    resolve: {
      ...lazyLoadModule(
        'curalate.agentsDashboard',
        () => import('@agents-dashboard/agentsDashboardApp'),
      ),
    },
  }),

  'agentsDashboard.chat': AgentsDashboardStateFactory({
    url: '/chat?:threadId&:initialMessage&:messageId',
    data: {
      title: 'Chat Agent',
      navGroup: NavGroup.AGENTS,
    },
  }),
};
